// Falls back to the local backend so a missing .env doesn't produce "undefined/api/v2" URLs
const API_HOST = (process.env.REACT_APP_BASE_URL || "http://localhost:5001").replace(/\/+$/, "");
const BASE_URL = `${API_HOST}/api/v2`;

const API_CONFIG = {
    // Base URL
    BASE_URL: BASE_URL,

    // Timeout configurations
    TIMEOUT: 10000, // Default timeout: 10 seconds

    // The tool binaries run to several MB each, which does not reliably clear
    // the default 10s on a slow link.
    DOWNLOAD_TIMEOUT: 120000,

    // API Endpoints with methods

    AUTH: {
        LOGIN: {
            ENDPOINT: `${BASE_URL}/auth/login`,
            METHOD: "POST",
        },
        REGISTER: {
            ENDPOINT: `${BASE_URL}/auth/register`,
            METHOD: "POST",
        },
        CHANGE_PASSWORD: {
            ENDPOINT: `${BASE_URL}/auth/changePassword`,
            METHOD: "POST",
        },
    },

    CLIENT: {
        GET: {
            ENDPOINT: `${BASE_URL}/client`,
            METHOD: "GET",
        },
        CREATE: {
            ENDPOINT: `${BASE_URL}/client`,
            METHOD: "POST",
        },
        UPDATE: {
            ENDPOINT: `${BASE_URL}/client/:id`,
            METHOD: "PUT",
        },
        TOGGLE_STATUS: {
            ENDPOINT: `${BASE_URL}/client/:id/status`,
            METHOD: "PATCH",
        },
        DELETE: {
            ENDPOINT: `${BASE_URL}/client/:id`,
            METHOD: "DELETE",
        },
    },

    PARTNER: {
        GET: {
            ENDPOINT: `${BASE_URL}/partner`,
            METHOD: "GET",
        },
        CREATE: {
            ENDPOINT: `${BASE_URL}/partner`,
            METHOD: "POST",
        },
        UPDATE: {
            ENDPOINT: `${BASE_URL}/partner/:id`,
            METHOD: "PUT",
        },
        TOGGLE_STATUS: {
            ENDPOINT: `${BASE_URL}/partner/:id/status`,
            METHOD: "PATCH",
        },
        DELETE: {
            ENDPOINT: `${BASE_URL}/partner/:id`,
            METHOD: "DELETE",
        },
    },

    RAN: {
        GET: {
            ENDPOINT: `${BASE_URL}/ran`,
            METHOD: "GET",
        },
        CREATE: {
            ENDPOINT: `${BASE_URL}/ran`,
            METHOD: "POST",
        },
        UPDATE: {
            ENDPOINT: `${BASE_URL}/ran/:id`,
            METHOD: "PUT",
        },
        TOGGLE_STATUS: {
            ENDPOINT: `${BASE_URL}/ran/:id/status`,
            METHOD: "PATCH",
        },
    },

    LICENSE: {
        LIST: {
            ENDPOINT: `${BASE_URL}/license`,
            METHOD: "GET",
        },
        CREATE: {
            ENDPOINT: `${BASE_URL}/license`,
            METHOD: "POST",
        },
        UPDATE: {
            ENDPOINT: `${BASE_URL}/license/:id`,
            METHOD: "PUT",
        },
        TOGGLE_STATUS: {
            ENDPOINT: `${BASE_URL}/license/:id/status`,
            METHOD: "PATCH",
        },
        DOWNLOAD: {
            ENDPOINT: `${BASE_URL}/license/:licenseId/download`,
            METHOD: "GET",
        },
        DELETE: {
            ENDPOINT: `${BASE_URL}/license/:licenseId`,
            METHOD: "DELETE",
        }
    },

    LICENSE_PRODUCTS: {
        ENABLED: {
            ENDPOINT: `${BASE_URL}/license-products/enabled`,
            METHOD: "GET",
        }
    },

    TRINETRA_LICENSE: {
        CONFIG: {
            ENDPOINT: `${BASE_URL}/trinetra-license/config`,
            METHOD: "GET",
        },
        CREATE: {
            ENDPOINT: `${BASE_URL}/trinetra-license`,
            METHOD: "POST",
        },
        LIST: {
            ENDPOINT: `${BASE_URL}/trinetra-license`,
            METHOD: "GET",
        },
        // Re-signs an existing license: same fingerprint and ID, new entitlements.
        UPDATE: {
            ENDPOINT: `${BASE_URL}/trinetra-license/:licenseId`,
            METHOD: "PUT",
        },
        DOWNLOAD: {
            ENDPOINT: `${BASE_URL}/trinetra-license/:licenseId/download`,
            METHOD: "GET",
        },
        DELETE: {
            ENDPOINT: `${BASE_URL}/trinetra-license/:licenseId`,
            METHOD: "DELETE",
        },
    },

    BINARY: {
        LIST: {
            ENDPOINT: `${BASE_URL}/binaries`,
            METHOD: "GET",
        },
        DOWNLOAD: {
            ENDPOINT: `${BASE_URL}/binaries/:key/download`,
            METHOD: "GET",
        },
    },

    DASHBOARD: {
        SUMMARY: {
            METHOD: "GET",
            ENDPOINT: `${BASE_URL}/dashboard/summary`,
        },
        LICENSES: {
            METHOD: "GET",
            ENDPOINT: `${BASE_URL}/dashboard/licenses`,
        },
        TRINETRA_SUMMARY: {
            METHOD: "GET",
            ENDPOINT: `${BASE_URL}/trinetra-license/dashboard-summary`,
        },
    },

    // Request Headers
    HEADERS: {
        "Content-Type": "application/json",
        Accept: "application/json",
    },

    // Token storage keys
    STORAGE_KEYS: {
        ACCESS_TOKEN: "access_token",
        USER: "license_user",
    },
};

export default API_CONFIG;
